module.exports = __webpack_public_path__ + "img/slide3-992.40068556.png";